import React from "react";
import { Heart, Sparkles, Globe } from "lucide-react";

export const Footer = () => (
  <footer
    data-testid="app-footer"
    className="relative z-10 border-t border-amber-200/40 mt-10"
  >
    <div className="max-w-3xl mx-auto px-6 py-12 text-center">
      {/* Brand / owner website */}
      <div className="flex items-center justify-center gap-2 mb-3">
        <Sparkles className="text-gold" size={18} />
        <span className="font-script text-4xl text-gold leading-none">Samantha</span>
        <Sparkles className="text-gold" size={18} />
      </div>
      <p className="font-play italic text-lg text-slate-600 mb-4">Hellsehen &amp; Kartenlegen</p>
      <a
        href="https://samantha-hellsehen-kartenlegen.de"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="owner-website-link"
        className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full gold-frame bg-white/60 text-gold font-medium tracking-wide hover:bg-white/90 transition-colors"
      >
        <Globe size={16} />
        samantha-hellsehen-kartenlegen.de
      </a>

      <span className="divider-gold w-40 inline-block my-8" />

      {/* Emergent credit */}
      <p className="text-slate-600 leading-loose text-[15px] max-w-xl mx-auto">
        Diese App wurde mit <span className="font-semibold text-gold">Emergent</span> gebaut – der
        KI-Plattform, mit der wunderschöne Apps ganz ohne Programmierkenntnisse entstehen.
        Von Herzen empfohlen für alle, die ihre Ideen zum Leuchten bringen möchten.
      </p>
      <div className="flex items-center justify-center gap-1.5 mt-5 text-slate-400 text-sm">
        <span>Erstellt mit</span>
        <a
          href="https://app.emergent.sh"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="emergent-link"
          className="font-semibold text-gold hover:underline"
        >
          Emergent
        </a>
        <Heart className="text-rose-300" size={14} fill="currentColor" />
      </div>
      <p className="text-slate-400 text-xs mt-4">
        © {new Date().getFullYear()} Samantha · Tier Seelen Analyse · Energetische Deutungen, keine medizinische Beratung.
      </p>
    </div>
  </footer>
);
